module.exports = __webpack_public_path__ + "static/supinfo-caf2c12eb44b21d6d470da90819915f9.png";